import { createContext } from 'react';
export var secondaryDimensionLengthContext = createContext(0);
